import React from "react";
import MainPage from "./MainPage";
import ErrorPage from "./ErrorPage";
import { Route, Routes } from "react-router-dom";


function App() {
  return (
    <Routes>

      <Route path="/" element={<MainPage />} />

      <Route path="/*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
